import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { Container } from '@fiverr-private/layout_components';
import { Text } from '@fiverr-private/typography';
import type { PhoneVerificationConfig } from '@fiverr-private/code_activation_triggers';

const T_PREFIX = 'gig_page_perseus.activation.phone';

export const startMessagingVerificationConfig: PhoneVerificationConfig = {
  title: (
    <Container textAlign="center" maxWidth="500px">
      <I18n k={`${T_PREFIX}.start_messaging.title`} />
    </Container>
  ),
  subtitle: (
    <Text size="b_sm" textAlign="center" maxWidth="450px">
      <I18n k={`${T_PREFIX}.start_messaging.subtitle`} />
    </Text>
  ),
};

export const requestToOrderVerificationConfig: PhoneVerificationConfig = {
  title: (
    <>
      <Container textAlign="center">
        <I18n k={`${T_PREFIX}.request_to_order.title_action`} />
      </Container>
      <Container textAlign="center">
        <I18n k={`${T_PREFIX}.request_to_order.title_reason`} />
      </Container>
    </>
  ),
  subtitle: (
    <Text size="b_sm" textAlign="center" maxWidth="500px">
      <I18n k={`${T_PREFIX}.request_to_order.subtitle`} />
    </Text>
  ),
};

export const customOrderVerificationConfig: PhoneVerificationConfig = {
  title: (
    <Container textAlign="center">
      <I18n k={`${T_PREFIX}.custom_order.title`} />
    </Container>
  ),
  subtitle: (
    <Text size="b_sm" textAlign="center" maxWidth="425px">
      <I18n k={`${T_PREFIX}.custom_order.subtitle`} />
    </Text>
  ),
};
